<template>
  <el-dialog :title="titleList[popType]" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="110px">
      <Title class="mb20" v-if="!popType">业务员基础信息</Title>
      <el-form-item label="业务员姓名：" prop="customerAddDTO.name" :class="{'width100': popType!=0}" v-if="[0,1].includes(popType)">
        <el-input v-model="form.customerAddDTO.name" placeholder="请输入业务员姓名" clearable />
      </el-form-item>
      <el-form-item label="手机号：" prop="customerAddDTO.pho" :class="{'width100': popType!=0}" v-if="[0,1].includes(popType)">
        <el-input v-model="form.customerAddDTO.pho" placeholder="请输入手机号" maxlength="11" clearable />
      </el-form-item>
      <template>
        <el-form-item label="用友编码：" prop="code" v-if="popType==0">
          <el-input v-model="form.customerAddDTO.code" placeholder="根据用友返回" disabled />
        </el-form-item>

        <el-form-item label="当前身份：" prop="name" v-if="popType==2" class="width100">
          <el-input v-model="form.customerAddDTO.levelName" disabled />
        </el-form-item>

        <el-form-item :label="popType==0?'身份：':'修改身份：'" :class="{'width100': popType==2}" prop="customerAddDTO.clevel" v-if="[0,2].includes(popType)">
          <el-select v-model="form.customerAddDTO.clevel" placeholder="请选择" clearable size="small" @change="handleTechnical(0)">
            <el-option v-for="(item,index) in businessStanding" :key="item.level" :label="item.name" :value="item.level"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="当前上级：" prop="parentId" v-if="form.levelId &&form.levelId != 1 && [4,6].includes(popType)" class="width100"> -->
        <el-form-item label="当前上级：" prop="parentId" v-if="[4,6].includes(popType) && customerParent" class="width100">
          <el-input v-if="customerParent && !customerParent.errorMsg" :value="`${customerParent.parentCustomerPO && customerParent.parentCustomerPO.name}(${customerParent.parentLevelPO && customerParent.parentLevelPO.name} ${customerParent.parentCustomerPO && customerParent.parentCustomerPO.pho})`" disabled />
          <el-input :value="customerParent.errorMsg" v-else disabled />
        </el-form-item>
        <!-- <el-form-item :label="popType==6?'更换上级：':popType==4?'上级：':'上级身份：'" prop="parentId" v-if="form.levelId && form.levelId != 1 && [0,2,4,6].includes(popType)" class="width100" :rules="[ -->
        <el-form-item :label="[6,10].includes(popType)?'更换上级：':popType==4?'上级：':'上级身份：'" prop="customerAddDTO.parentId" v-if=" [4,6,10].includes(popType) || ([0,2].includes(popType)  && form.customerAddDTO.clevel && form.customerAddDTO.clevel!=1)" :class="{'width100':[2,4,6,10].includes(popType)}" :rules="[
      { required: ![6,10].includes(popType), message: '请选择上级身份', trigger: 'change' }]">
          <el-select v-model="form.customerAddDTO.parentId" placeholder="请选择上级" clearable size="small" @change="changeIdentity" filterable :filter-method="identityFilter" @blur="handleTechnical(1)">
            <el-option v-for="(item,index) in options.identityOptions" :key="item.id" :label="`${item.name} (${item.pho}) ${item.levelName}`" :value="item.id"></el-option>
          </el-select>
          <span style="color: #8F8E8E;" v-if="[6,10].includes(popType)">不更换上级，系统默认读取原来的上级</span>
        </el-form-item>
        <el-form-item label="申请原因：" prop="content" class="width100" v-if="popType==2">
          <el-input v-model="form.content" type="textarea" :rows="3" placeholder="请输入申请原因" />
        </el-form-item>
        <el-form-item label="附件：" prop="applyVoucher" class="width100" v-if="popType==2">
          <el-upload :action="uploadUrl" list-type="picture-card" :file-list="applyVoucherList" :on-success="handleApplyVoucherUpload" :on-remove="handleApplyVoucherRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item :label="popType==5?'区域：':'管辖区域：'" prop="areaAddDTO" :class="{'width100':popType==5}" v-if="[0,3,5].includes(popType) && ((form.customerAddDTO.clevel!=1 && form.customerAddDTO.parentId) || (form.customerAddDTO.clevel==1 ))" :rules="[
      { required: true, message: '请选择区域', trigger: 'change' }]">
          <el-cascader v-model="form.areaAddDTO" :props="cascaderProps" collapse-tags :options="options.areaAddDTO" clearable></el-cascader>
        </el-form-item>
        <el-form-item label="所在区域" prop="addr" class="width100" v-if="[0,1].includes(popType)">
          <!-- <el-cascader v-model="form.customerAddDTO.addr" :props="cascaderProps1" separator='' collapse-tags
          :options="addressList" clearable disabled></el-cascader> -->
          <el-cascader v-model="form.addr" :props="cascaderProps1" collapse-tags :options="addressLists" @change="regionChange" clearable placeholder="请选择省市区"></el-cascader>
          <!-- <el-cascader v-model="form.areaList" :props="cascaderProps" collapse-tags :options="options.technicianAreOptions" clearable popper-class="cascader-box"></el-cascader> -->
        </el-form-item>
        <el-form-item label="观察状态：" prop="customerAddDTO.isIntern" v-if="[0,9].includes(popType) && [3].includes(form.customerAddDTO.clevel)" :rules="[{ required: [0,9].includes(popType) && [3].includes(form.customerAddDTO.clevel), message: '请选择观察状态', trigger: 'change' }]">
          <el-radio-group v-model="form.customerAddDTO.isIntern">
            <el-radio :label="1">实习期</el-radio>
            <el-radio :label="0">转正</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="观察时间：" prop="customerAddDTO.ywInternTime" v-if="[0,9].includes(popType) && [3].includes(form.customerAddDTO.clevel) && form.customerAddDTO.isIntern" :rules="[{ required: true, message: '请选择观察时间', trigger: 'change' }]">
          <el-date-picker v-model="form.customerAddDTO.ywInternTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <template v-if="form.customerAddDTO.clevel==3 && (!popType || popType==8)">
          <Title class="mb20" v-if="!popType">分润比例</Title>
          <el-form-item label="体验班：" prop="customerAddDTO.incomeRatio2" :rules="[{ required: true, message: '请输入体验班分润比例', trigger: 'blur' },{ pattern: /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/, message: '请输入正确的费用'}]">
            <el-input placeholder="请输入" v-model="form.customerAddDTO.incomeRatio2">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="研修班：" prop="customerAddDTO.incomeRatio" :rules="[{ required: true, message: '请输入研修班分润比例', trigger: 'blur' },{ pattern: /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/, message: '请输入正确的费用'}]">
            <el-input placeholder="请输入" v-model="form.customerAddDTO.incomeRatio">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </template>

      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import technicianInfoApi from '@/api/technical/technicianInfo'
import technicianAreaApi from '@/api/technical/technicianArea'
import clientListApi from '@/api/client/clientList'
import clientAreaApi from '@/api/client/clientArea'
import SearchCityCompanyApi from '@/api/sys/CityCompanyAddrArea'
function initFormBean() {
  const formBean = {
    customerAddDTO: {
      name: null,
      pho: null,
      code: '',
      clevel: null,
      parentId: null,
      customerType: 2,
      source: '后台录入',
      incomeRatio: null,
      incomeRatio2: null,
      isIntern: 1,
      ywInternTime: null
      // status: 10,
    },
    addr: [],
    areaAddDTO: [],
    content: ''

  }
  return formBean
}

export default {
  props: ['businessStanding', 'popType', 'configList', 'addressLists'],
  //popType 0:新增 1:编辑 2:修改身份 3:团队调整-添加老师 4:调整上级 5添加区域 6 设为在职7：客户调整 8:分润比例 9:观察时间 10:批量设为在职
  data() {
    return {
      titleList: ['添加业务员', '编辑业务员基础信息', '修改身份', '', '调整上级', '添加区域', '设为在职身份', '客户调整', '分润比例', '观察时间'],
      options: {
        identityOptions: [],
        technicianAreOptions: [],
        areaAddDTO: []
      },
      isLoading: false,
      form: initFormBean(),
      formVisible: false,
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      applyVoucherList: [],
      formRules: {
        'customerAddDTO.name': [{ required: true, message: '请输入姓名老师', trigger: 'blur' }],
        'customerAddDTO.pho': [{ required: true, message: '请输入手机号', trigger: 'blur' },
        { pattern: /^[0-9]*$/, message: '请输入正确的手机号' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }],
        // code: [{ required: true, message: '请输入用友编码', trigger: 'blur' }],
        'customerAddDTO.clevel': [{ required: true, message: '请选择身份', trigger: 'change' }],
        // areaAddDTO:[{ required: true, message: '请选择区域', trigger: 'change' }]
        addr: [{ required: true, message: '请选择所在区域', trigger: 'change' }],
      },
      cascaderProps: {
        label: 'areaName',
        value: 'areaCode',
        children: 'child',
        multiple: true
      },
      cascaderProps1: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
      },
      info: {},
      selectItems: [],
      customerParent: null
    }
  },
  created() {
  },
  methods: {
    identityFilter(e) {
      this.handleTechnical(1, e)
    },
    // 获取业务员
    handleTechnical(type, val) {
      // console.log('type: ',type);
      if (!type) {
        this.form.customerAddDTO.parentId = null
      }
      if (this.form.customerAddDTO.clevel == 1) return this.changeIdentity()
      let obj = {
        maxLevel: this.form.customerAddDTO.clevel,
        customerTypes: 2,
        isGetAllParent: true,
        isDeparted: 0,
        pageNo: 1,
        pageSize: 100
      }
      // if(val){
      obj.name = val
      // }
      //status  10 已入职  20  离职交接  30 已离职
      clientListApi.getListPageForMini(obj).then(({ data }) => {
        this.options.identityOptions = data.list
        console.log(data.list);
      })
    },
    // 获取区域列表
    changeIdentity() {
      // return
      if (this.popType == 4) return
      let obj = {
        addOrDelete: 1,
        parentCustomerId: this.form.customerAddDTO.parentId || 0,
        v:3
      }
      // if (this.form.customerAddDTO.clevel != 1) {
      //   obj.customerId = this.form.customerAddDTO.parentId
      // }
      obj.customerId = this.form.customerAddDTO.id || 0
      if ([0, 5].includes(this.popType)) {
        // obj.isGetTeamAuth = false
      }
      if (!this.popType || this.popType == 5) {
        this.loading = this.$loading({
          lock: true,
          text: "加载中",
          background: "rgba(0, 0, 0, 0.7)",
        });
      }
      clientAreaApi.fetchTreeList(obj).then(({ data }) => {
        if (!this.popType || this.popType == 5) { this.loading.close() }
        if (this.popType == 5) {
          this.formVisible = true
        }
        if (data) {
          this.options.areaAddDTO = this.formatCascaderData(data)
        } else {
          this.options.areaAddDTO = []
        }
      }).catch(() => {
        this.loading.close();
      })
    },
    // 获取区域列表
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({ data }) => {
        this.addressList = data
        console.log('地区列表: ', data);
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
      this.applyVoucherList = []
    },
    handleApplyVoucherUpload(response, file, fileList) {
      if (file && file.response) {
        this.applyVoucherList.push({ url: file.response.data })
      }
    },
    handleApplyVoucherRemove(file, fileList) {
      this.applyVoucherList = fileList
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        console.log('configList: ', this.configList);
        this.form.customerAddDTO.incomeRatio2 = this.configList.find(i => i.code == 'profitSharingRatioForL7').content
        this.form.customerAddDTO.incomeRatio = this.configList.find(i => i.code == 'profitSharingRatioForL6').content
      })
    },
    getCustomerParent(customerid) {
      clientListApi.getCustomerParent({ customerid }).then(({ data }) => {
        this.customerParent = data
      })
    },
    async handleUpdate(command) {
      this.resetForm()
      if ([4, 6].includes(command.command)) this.getCustomerParent(command.row.customer.id)
      let { data } = await clientListApi.fetchById(command.row.customer.id)
      this.rowItem = data
      if (command.command != 10) {
        this.info = data
        this.form.customerAddDTO = { ...data.customer }
        if (data.addr && data.addr.length) {
          this.form.addr = [data.addr[0].regionCode, data.addr[1].regionCode, data.addr[2] && data.addr[2].regionCode]
        }
        if (this.form.customerAddDTO.ywInternTime) {
          this.form.customerAddDTO.ywInternTime = this.dayjs(data.customer.ywInternTime).format("YYYY-MM-DD HH:mm:ss")
        }
      } else {
        this.selectItems = data
      }
      // console.log('this.form: --------',this.form,this.popType,data);
      if ([2, 4, 6, 10].includes(command.command)) {
        if (command.command == 2) {
          this.form.customerAddDTO.levelName = data.customerLevel.name
          this.form.customerAddDTO.parentId = null
        }
        // this.form.parentId=''
        // if(command.command==4 || command.command==6 || command.command==10){
        this.handleTechnical(1)
        // }
        // this.form.levelName=this.technicalServiceLevel.find(i=>i.levelId==row.levelId).levelId
        // if(row.levelId!=1){
        //   this.handleTechnical()
        // }

      }
      if (command.command == 5) {
        this.changeIdentity()
      } else {
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      }
    },
    regionChange(e) {
      if (!this.popType) this.getCityCompany(e)
      // 手动触发所在区域的验证
      this.$refs['dataForm'].validateField('addr');
    },
    getCityCompany(e) {
      SearchCityCompanyApi.SearchCityCompany({ provinceCode: e[0], cityCode: e[1], districtCode: e[2] }).then(({ data }) => {
        if (data) {
          this.form.customerAddDTO.cityCompanyId = data.id
        }
      })
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.areaAddDTO = params.areaAddDTO && params.areaAddDTO.length > 0 ? params.areaAddDTO.map(i => {
        return { provinceCode: i[0], cityCode: i[1], districtCode: i[2], areaType: 3, customerId: this.form.customerAddDTO.id }
      }) : null
      return params
    },
    doCreate() {
      console.log(this.form)
      this.$refs["dataForm"].validate((valid, valid1) => {
        if (valid) {

          let params = this.calcParams();
          if (this.form.customerAddDTO.clevel != 3) {
            params.customerAddDTO.isIntern = 0
            delete params.customerAddDTO.ywInternTime
            params.customerAddDTO.incomeRatio = null
            params.customerAddDTO.incomeRatio2 = null
          }

          // 新增
          console.log('params: ', params);
          // return
          if ([0].includes(this.popType)) {
            if (!this.popType) {
              params.customerAddDTO.addrProvinceCode = params.addr[0]
              params.customerAddDTO.addrCityCode = params.addr[1]
              params.customerAddDTO.addrAreaCode = params.addr[2]
              params.customerAddDTO.state = 1
              params.dataCompareLogType2 = 2
              if (this.form.customerAddDTO.clevel == 1) {
                params.customerAddDTO.parentId = null
              }
              delete params.addr
            }
            // else{
            //   params.dataCompareLogType2=21
            // }
            // params.customerAddDTO.isIntern=0
            // params.registrationType=1
            console.log('params111: ', params);
            params.isUseParentWallet = 0
            this.isLoading = true
            clientListApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            });
          }
          // 编辑
          if ([1, 8].includes(this.popType)) {
            const editParams = {
              ...this.form.customerAddDTO,
              dataCompareLogType2: this.popType == 1 ? 16 : 21
            }
            // if(this.popType==1){
            editParams.addrProvinceCode = this.form.addr[0]
            editParams.addrCityCode = this.form.addr[1]
            editParams.addrAreaCode = this.form.addr[2]
            // delete editParams.addr
            // }
            this.isLoading = true
            clientListApi.update(editParams).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            });
          }
          // 修改身份
          if (this.popType == 2) {
            const editParams = {
              id: this.form.customerAddDTO.id,
              parentId: this.form.customerAddDTO.parentId || 0,
              clevel: this.form.customerAddDTO.clevel,
              // 业务员改身份直接生效、不走身份变动审核，这里必须传 null。
              // 传对象会让后端 update2 去插 customer_registration，而本页没有 customerId/fee，
              // customer_registration.customer_id 是 NOT NULL，必然 500（见 620e8d7 引入的问题）
              customerRegistrationAddDTO: null,
              customerCertificatesUpdateDTO: null,
              name: this.form.customerAddDTO.name,
              // 不生成审核单，申请原因和附件直接落在 customer 上，详情页“修改身份记录”里展示
              lastDonote: this.form.content || null,
              lastApplyVoucher: this.applyVoucherList.map(item => item.url).join(',') || null,
              dataCompareLogType2: 17,
              version: 2
            }
            this.isLoading = true
            clientListApi.updateLevel(editParams).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            });
          }
          if (this.popType == 4) {
            const editParams = {
              id: this.form.customerAddDTO.id,
              parentId: this.form.customerAddDTO.parentId,
              customerType: this.form.customerAddDTO.customerType,
              technicianId: this.form.customerAddDTO.technicianId,
              dataCompareLogType2: 18
            }
            this.isLoading = true
            clientListApi.updateSuperiors1([editParams]).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            });
          }
          if (this.popType == 5) {
            // console.log('params: ',params);
            // return
            clientAreaApi.saveBatch(params.areaAddDTO).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            });
          }
          if (this.popType == 6 || this.popType == 10) {
            let arr = []
            if (this.popType == 6) {
              let obj = {
                customerid: this.form.customerAddDTO.id,
                isDeparted: 0,
                dataCompareLogType2: 20
              }
              if (this.form.customerAddDTO.parentId) {
                obj.newParentCustomerid = this.form.customerAddDTO.parentId
              }
              arr = [obj]
              // console.log('arr: ',arr);
            } else {
              // console.log('selectItems: ',this.selectItems);
              if (this.form.customerAddDTO.parentId) {
                arr = this.selectItems.map(item => ({ customerid: item.customer.id, isDeparted: 0, newParentCustomerid: this.form.customerAddDTO.parentId, dataCompareLogType2: 20 }))
              } else {
                arr = this.selectItems.map(item => ({ customerid: item.customer.id, isDeparted: 0, dataCompareLogType2: 20 }))
              }
              // console.log('arr2222: ',arr);
            }
            this.isLoading = true
            clientListApi.setEntry(arr).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            });
          }
          if (this.popType == 9) {
            // console.log('params: ',params);
            // return
            let query = {
              customerId: params.customerAddDTO.id,
              isIntern: params.customerAddDTO.isIntern,
              dataCompareLogType2: 22
            }
            if (params.customerAddDTO.canStudy != null) {
              query.canStudy = params.customerAddDTO.canStudy
            }
            if (params.customerAddDTO.isIntern) {
              query.ywInternTime = params.customerAddDTO.ywInternTime
            }
            this.isLoading = true
            clientListApi.updateStudy(query).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            });
          }
        }
      });
    },
    async postCallback(response) {
      this.$message.success(`${[6, 10, 4].includes(this.popType) ? '提交成功！您的任务已开始执行，请耐心等待。您可以前往任务表查看进度' : '操作成功'}`)

      this.isLoading = false
      if (this.popType === 1) {
        let { customer, cityCompany } = this.rowItem
        let { data } = await clientListApi.checkCityCompany({ customerid: customer ? customer.id : '', cityCompanyId: cityCompany ? cityCompany.id : '' })
        if (data.isChaoChu) {
          this.$confirm(`客户所属区域改变，是否同步修改城市公司`, '提示', {
            confirmButtonText: '同步修改',
            cancelButtonText: '暂不修改',
            type: 'warning'
          }).then(() => {
            this.formVisible = false;
            this.isLoading = false
            this.$emit('created', this.rowItem)
          }).catch(() => {
            this.formVisible = false;
            this.$emit('created')
          });
        } else {
          this.formVisible = false;
          this.$emit('created')
        }
      } else {
        this.formVisible = false;
        this.$emit('created')
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-date-editor--datetime {
  width: 100%;
}
</style>
